<div class="fx-row fx-gap-sm y-center">

  <!-- Icon -->
  @if (iconTemplate || config?.icon || icon) {
    <div class="header-icon fx-column y-center">
      @if (iconTemplate) {
        <ng-container
          [ngTemplateOutlet]="iconTemplate" />
      } @else {
        <mat-icon class="material-icons-outlined">{{(config?.icon || icon)}}</mat-icon>
      }
    </div>
  }

  <!-- Header / Subheader -->
  <div class="text-container fx-column fx-1-1-0" [ngClass]="'overflow-' + overflow">

    @if ((config?.header || header); as text) {
      <span class="header-text" [innerHTML]="text" [ngClass]="headerClass +' overflow-' + overflow">
      </span>
    }

    @if ((config?.subheader || subheader); as text) {
      <span class="subheader-text" [innerHTML]="text"
        [ngClass]="subheaderClass + ' overflow-' + overflow">
      </span>
    }

  </div>

  <!-- Action -->
  @if (suffixTemplate || config?.suffixIcon || suffixIcon) {
    <div class="header-suffix fx-column y-center">
      @if (suffixTemplate) {
        <ng-container
          [ngTemplateOutlet]="suffixTemplate" />
      } @else {
        <mat-icon class="material-icons-outlined">{{(config?.suffixIcon || suffixIcon)}}</mat-icon>
      }
    </div>
  }


</div>
